import EfficeIconLarge from "components/General-UI/EfficeIconLarge";
import ShortenedTitle from "components/General-UI/ShortenedTitle";
import EfficeDetailTime from "components/Home/MainContent/Text/TextBody/InfoPage/EfficeDetailTime/EfficeDetailTime";
import { AddPeopleIcon } from "graphics/icons/InfoPage/AddPeopleIcon";
import { BranchType } from "graphics/icons/InfoPage/BranchType";
import { Content } from "graphics/icons/InfoPage/Content";
import { MembersIcon } from "graphics/icons/InfoPage/MembersIcon";
import { PermissionsIcon } from "graphics/icons/InfoPage/PermissionsIcon";
import { TimeCreated } from "graphics/icons/InfoPage/TimeCreated";
import { UpArrow } from "graphics/icons/InfoPage/UpArrow";
import {
  canIEdit,
  iAmAdmin,
  isBranchApp,
  isPrivateEffice,
  isTextNode,
  nameThisNode,
} from "helpers/efficeHelpers";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserAttributes, selectMyGuid } from "slices/authSlice";
import { deleteEfficeRequest, goToEffice } from "slices/efficeTreeSlice";
import { PERMISSIONS, resetPermissionsMembers } from "slices/peopleSlice";
import {
  EFFICE,
  selectCurrentActiveEffice,
  selectCurrentActiveType,
  selectCurrentPermissionsEffice,
  selectCurrentPID,
} from "slices/sharedSelectors";
import InfoText from "./InfoText/InfoText";
import MemberSideList from "./MemberSideList/MemberSideList";
import PermissionsList from "./PermissionsList/PermissionsList";
import RootIconEditModal from "./RootIconEditModal/RootIconEditModal";
import {
  setAddPeopleModal,
  setConfirmationModal,
  closeInfoPage,
} from "slices/textSlice";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import { APPS_AVAILABLE, APP_CODE_TEXT_CHANNEL } from "constants/constants";
import AppIcon from "components/Home/ui/AppIcon/AppIcon";
import { setAppModal } from "slices/generalSlice";

function InfoPage() {
  const dispatch = useDispatch();
  const currentActiveType = useSelector(selectCurrentActiveType);
  const currentEff = useSelector(selectCurrentActiveEffice);
  const permEff = useSelector(selectCurrentPermissionsEffice);
  const currentPID = useSelector(selectCurrentPID);
  const myDeets = useSelector(selectCurrentUserAttributes);
  const myId = useSelector(selectMyGuid);
  const [rootIconEditModal, setRootIconEditModal] = useState(false);
  const amAdmin = iAmAdmin(currentEff);
  const isPrivate = isPrivateEffice(currentEff);

  useEffect(() => {
    return () => {
      dispatch(resetPermissionsMembers());
    };
  }, [dispatch, currentPID]);

  function renderApps() {
    let items = [];
    APPS_AVAILABLE.forEach(({ appId, name }) => {
      items.push(
        <button
          className="app-container"
          onClick={() =>
            dispatch(setAppModal({ nodeId: currentEff.id, appId }))
          }
          key={appId}
        >
          <span className="app-plus">+</span>
          <div className="app-icon">
            <AppIcon appId={appId} />
          </div>
          <br />
          <div className="app-name dotdotdot">{name}</div>
        </button>
      );
    });
    return items;
  }

  return (
    <div className="info-page-wrapper" onClick={closeInfoPage}>
      <div
        className={`info-page ${isBranchApp(currentEff) ? "brancher" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {amAdmin && isBranchApp(currentEff) && (
          <div className="segment">
            <h1>add an app to {currentEff.content}</h1>
            <div className="segment">{renderApps()}</div>
            <hr />
          </div>
        )}
        <div className="segment">
          <h1>Details</h1>
          {amAdmin && (
            <button
              className="deleter"
              onClick={() => {
                dispatch(
                  setConfirmationModal({
                    header: `Delete ${currentActiveType}?`,
                    content: (
                      <>
                        Are you sure you want to delete&nbsp;
                        <span className="font-bold">
                          <ShortenedTitle
                            title={currentEff.content}
                            maxChars={50}
                          />
                        </span>
                        &nbsp;for everyone? This will cause everything inside,
                        including branches and messages, to be deleted as well!
                      </>
                    ),
                    action: () => {
                      dispatch(deleteEfficeRequest(currentEff.id));
                    },
                    danger: true,
                  })
                );
              }}
            >
              Delete {nameThisNode(currentEff)}...
            </button>
          )}
          <div className="segment details">
            {currentActiveType === EFFICE && (
              <div className="icon">
                <EfficeIconLarge
                  rootName={currentEff.content}
                  rootIcon={currentEff.avatar_key}
                />
                {amAdmin && (
                  <span
                    className="editter"
                    onClick={() => setRootIconEditModal(true)}
                  >
                    edit
                  </span>
                )}
              </div>
            )}
            <div className="text-details">
              <div className="deetrow">
                <div className="subtitle beside">
                  App <BranchType />
                </div>
                <div className="normal-text beside">
                  {`${isPrivate ? "Private" : "Public"} ${nameThisNode(
                    currentEff
                  )}`}
                </div>
              </div>
              <div className="deetrow">
                <div className="subtitle beside">
                  Time Created <TimeCreated />
                </div>
                <div className="normal-text beside">
                  <EfficeDetailTime time={currentEff.created_at} />
                  {currentEff.editted_at && (
                    <span style={{ fontSize: "12px" }}>
                      &nbsp; &nbsp; (editted{` `}
                      <EfficeDetailTime time={currentEff.created_at} />)
                    </span>
                  )}
                </div>
              </div>
              <div className="deetrow">
                <div className="subtitle beside">
                  {isTextNode(currentEff) ? "Original Message" : "Name"}
                  <Content />
                </div>
                <div className="normal-text beside">
                  <InfoText currentActiveEffice={currentEff} myId={myId} />
                </div>
              </div>
            </div>
          </div>
          {currentEff.app_id === APP_CODE_TEXT_CHANNEL && (
            <div className="segment">
              <div className="subtitle beside">
                Permissions <PermissionsIcon />
              </div>
              <div className="normal-text beside">
                <PermissionsList permissionsEffice={permEff} />
              </div>
            </div>
          )}

          {canIEdit(currentEff, currentEff.role_id, myId) && (
            <div className="segment"></div>
          )}

          <div
            className={`segment ${!isPrivate && amAdmin ? "hide-options" : ""}`}
          >
            <div className="subtitle members-title">
              Members <MembersIcon />
            </div>
            {!isPrivate ? (
              <div
                onClick={() => goToEffice(permEff.id)}
                className="same-as member-change"
              >
                <em>
                  Same As{" "}
                  <span
                    style={{
                      position: "relative",
                      bottom: "2px",
                      margin: "0 5px 0 6px",
                    }}
                  >
                    <PrivateLockBlue />
                  </span>
                  <strong className="business-color">
                    <ShortenedTitle title={permEff.content} maxChars={50} />
                  </strong>
                </em>
                {amAdmin && (
                  <button className="edit-people">
                    <UpArrow />
                    Edit Members
                  </button>
                )}
              </div>
            ) : amAdmin ? (
              <button
                className="add-people"
                onClick={() => dispatch(setAddPeopleModal(currentEff.id))}
              >
                Add People <AddPeopleIcon />
              </button>
            ) : null}
            <br />
            <MemberSideList
              pid={permEff.id}
              type={PERMISSIONS}
              permissionsEffice={permEff}
              myDeets={myDeets}
            />
          </div>
          {rootIconEditModal ? (
            <RootIconEditModal
              currentActiveEffice={currentEff}
              onExit={() => setRootIconEditModal(false)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default InfoPage;
